import { GamepadLayoutType } from './gamepad.types';
import { JoystickInputs } from './joystickMap';

export const GamepadLayout: GamepadLayoutType = {
  global: {
    moveToNextVideo: JoystickInputs.Shoulder.RT,
    moveToPrevVideo: JoystickInputs.Shoulder.LT,
    activate: JoystickInputs.Face.B,
    toggleFullscreenVideo: JoystickInputs.RightStick.Press,
  },

  camera: {
    cameraPanTilt: JoystickInputs.LeftStick.Move,
    cycleCamera: JoystickInputs.Face.X,
  },
  winch: {
    moveWinch2D: JoystickInputs.RightStick.Move,
  },
  layout: {
    nextLayout: JoystickInputs.Shoulder.RB,
    previousLayout: JoystickInputs.Shoulder.LB,
    toggleCameraSelector: JoystickInputs.LeftStick.Press,
  },
};
